import { render, staticRenderFns } from "./EcommerceGoalOverview.vue?vue&type=template&id=4b0c5c0f&scoped=true&"
import script from "./EcommerceGoalOverview.vue?vue&type=script&lang=js&"
export * from "./EcommerceGoalOverview.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceGoalOverview.vue?vue&type=style&index=0&id=4b0c5c0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c5c0f",
  null
  
)

export default component.exports